/* eslint-disable replo/no-tailwind-literal-color */
import React, { useState } from "react";

import { selectProjectId } from "@editor/reducers/core-reducer";
import { useEditorSelector } from "@editor/store";
import { trpc } from "@editor/utils/trpc";

import Button from "@replo/design-system/components/button/Button";
import Popover from "@replo/design-system/components/popover/Popover";
import { skipToken } from "@tanstack/react-query";

import { useReactRenderStore } from "../store/reactRenderStore";

function ManageChats() {
  const projectId = useEditorSelector(selectProjectId);
  const { chatId: chatIdStore, setChatId } = useReactRenderStore();

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const { mutate: createChat, isPending: createChatLoading } =
    trpc.chat.create.useMutation({
      onSuccess: (chat) => {
        setChatId(chat.id);
        void refetchChats();
      },
    });

  const { data: chats, refetch: refetchChats } =
    trpc.chat.listAllOrCreate.useQuery(projectId ? { projectId } : skipToken);

  const chatId = chatIdStore ?? chats?.[0]?.id;

  const handleNewChat = () => {
    if (!projectId) {
      return;
    }

    createChat({ projectId });
  };

  return (
    <div className="flex gap-2">
      <Button
        isLoading={createChatLoading}
        variant="secondary"
        onClick={handleNewChat}
      >
        New Chat
      </Button>
      <Popover.Root isOpen={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
        <Popover.Trigger>
          <Button variant="secondary">Manage Chats</Button>
        </Popover.Trigger>
        <Popover.Content
          title="Past Chats"
          shouldPreventDefaultOnInteractOutside={false}
        >
          <div className="flex flex-col gap-2 text-base font-normal text-gray-900">
            {chats?.map((chat) => (
              <div
                key={chat.id}
                className={`flex cursor-pointer items-center gap-2 rounded px-2 py-1 transition hover:bg-gray-100 ${chat.id === chatId ? "bg-blue-100 font-semibold" : ""}`}
                onClick={() => setChatId(chat.id)}
              >
                <div>{chat.title}</div>
                <div className="text-sm text-gray-500">
                  {new Date(chat.createdAt).toLocaleTimeString()}
                </div>
              </div>
            ))}
          </div>
        </Popover.Content>
      </Popover.Root>
    </div>
  );
}

export default ManageChats;
